<script lang="ts">
    import Artwork from '~/components/jet/Artwork/Artwork.svelte';

    export let header;

    $: artwork = header.artwork;
    $: title = header.title;

    $: uberBackgroundColor = !!artwork?.backgroundColor
        ? `#${artwork?.backgroundColor}`
        : null;
</script>

<div class="uber">
    <div
        class="uber__image"
        style:--uber-background-color={uberBackgroundColor}
        data-testid="uber-image"
    >
        <Artwork {artwork} profile="uber" forceFullWidth={false} />
    </div>
</div>
{#if title}
    <h1 class="uber-title" data-testid="uber-title">
        {title}
    </h1>
{/if}

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'ac-sasskit/core/media' as *;
    @use '@amp/web-shared-styles/app/core/viewports' as *;
    @use 'sass:math';

    .uber {
        position: relative;
    }

    .uber__image {
        $uber-image-height: 300px;

        :global(.artwork-component) {
            $uber-artwork-ios-aspect-ratio: math.div(7, 4);
            --override-placeholder-bg-color: var(--uber-background-color);
            --artwork-override-height: #{$uber-image-height};
            max-height: $uber-image-height; // Helps with aspect-ratio improvements, below

            // Preserve safe area on smaller viewports. No need to adjust mask-size
            // Using iOS aspect ratio for mobile views
            @media (--range-sidebar-hidden-down) {
                --artwork-override-height: calc(
                    100vw / #{$uber-artwork-ios-aspect-ratio}
                );
            }

            @media (--range-sidebar-visible-up) and (--range-xsmall-down) {
                --artwork-override-height: calc(
                    (100vw - var(--web-navigation-width)) / #{$uber-artwork-ios-aspect-ratio}
                );
            }
        }

        :global(.artwork-component__image) {
            --artwork-override-height: 100%;
            --artwork-override-width: auto;
            position: absolute;
            // RTL Not needed for horizontal centering
            left: 50%;
            transform: translateX(-50%);

            @media (--small) {
                // Applying the mask directly to the image fixes a bug where the side edges of the uber image
                // are visible when the viewport become too small. This was visible on the activity and record label page.
                mask-size: 100% $uber-image-height;
                mask-position: center;
                mask-image: url('/assets/uber/MasterArtMaskOptimized.png');

                @include retina {
                    mask-image: url('/assets/uber/MasterArtMaskOptimized@2x.png');
                }
            }
        }
    }

    .uber-title {
        padding: 32px var(--bodyGutter) 7px;
        font: var(--large-title-emphasized-serif);
        color: var(--systemPrimary);
    }
</style>
